import {useTranslation} from "react-i18next";
import {Box, DialogContent, DialogTitle, Divider, LinearProgress, Modal, ModalDialog, Stack} from "@mui/joy";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHourglassHalf} from "@fortawesome/pro-regular-svg-icons";

export interface SuspenseDialogProps {
    message?: string;
}

export function SuspenseDialog({message}: SuspenseDialogProps) {
    const {t} = useTranslation();
    //    const routerState = useRouterState();
    return <Modal open={true}
                  sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <ModalDialog variant="soft" role="alertdialog" color="primary">
            <DialogTitle>
                <FontAwesomeIcon icon={faHourglassHalf} size="2x"/>
                {t("suspended")}
            </DialogTitle>
            <Divider/>
            <DialogContent>
                <Stack direction="column" spacing={1.8}>
                    {message
                        ? <Box>{message}</Box>
                        : null}
                    <LinearProgress thickness={3}/>
                </Stack>
            </DialogContent>
        </ModalDialog>
    </Modal>
}
